import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'
import { useCurrentOrganization } from '@/hooks/use-current-organization'
import { useAuthContext } from './use-auth-context'

export function useIdentifyUser() {
  const { user, membership } = useAuthContext()
  const { organization } = useCurrentOrganization({ enabled: Boolean(user) })
  const posthog = usePostHog()

  useEffect(() => {
    if (!user || !posthog) return

    posthog.identify(user.email, {
      email: user.email,
      name: user.name,
      id: user.id,
      ...(organization && { organizationId: organization.id }),
      ...(membership?.role && { role: membership.role }),
    })

    if (organization) {
      posthog.group('company', organization.id, { name: organization.name })
    }
  }, [user, membership, organization, posthog])
}
